'use client';

import type { Ref } from 'react';

import classnames from 'classnames';

import type { StepperLabelProps } from '../Stepper.types';

import styles from './StepperLabel.module.scss';

export function StepperLabel({
  style,
  className,
  label,
  icon,
  variant,
  testId = 'ui-stepper-label',
  ref,
  ...rest
}: StepperLabelProps & { ref?: Ref<HTMLButtonElement> }) {
  return (
    <button
      ref={ref}
      style={style}
      className={classnames(
        styles['stepper-label'],
        variant && styles[`stepper-label--${variant}`],
        className,
      )}
      data-testid={testId}
      {...rest}
    >
      {icon ? (
        <span className={styles['icon-wrapper']}>
          <span className={styles['icon-wrapper__icon']}>{icon}</span>
        </span>
      ) : null}
      <span className={styles['label']}>{label}</span>
    </button>
  );
}
